import { useEffect, useState } from "react";
import { getDentalCase } from "../services/dentalArchService";
import type { DentalCaseData } from "../types/dental";

interface UseArchDataResult {
  data: DentalCaseData | null;
  isLoading: boolean;
  error: string | null;
}

export function useArchData(caseId: string | null): UseArchDataResult {
  const [data, setData] = useState<DentalCaseData | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!caseId) {
      setData(null);
      setIsLoading(false);
      setError(null);
      return;
    }

    const resolvedCaseId = caseId;

    setData(null);
    setError(null);
    setIsLoading(true);

    let isMounted = true;

    async function load(): Promise<void> {
      try {
        const result = await getDentalCase(resolvedCaseId);

        if (isMounted) {
          setData(result);
        }
      } catch (err) {
        if (isMounted) {
          setError(err instanceof Error ? err.message : "Unknown error");
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    }

    void load();

    return () => {
      isMounted = false;
    };
  }, [caseId]);

  return { data, isLoading, error };
}